<mat-dialog-content>
  <form class="d-flex direction-column align-center form" [formGroup]="form">
    <button class="form-close close" (click)="close(false)">
      <app-svg-icon
        class="form-close-icon"
        src="../../../../assets/icons/close-icon.svg"
        width="17px"
      ></app-svg-icon>
    </button>

    <div class="d-flex align-center justify-space-between form-conteudo">
      <ng-container *ngFor="let input of inputs; let i = index">
        <app-c-input
          *ngIf="
            !input?.select &&
            ((!input.readonly && data.form) ||
              (!input.readonly && !data.form)) &&
            !input.isHidden
          "
          class="form-conteudo-cinput"
          [label]="input.label"
          [placeholder]="input.placeholder"
          [value]="input.value"
          [formControlName]="input.controlName"
          [inputMask]="input.mask"
          [currencyMask]="!!input.currency"
          [dropSpecial]="false"
          [readonly]="!editableFields.includes(input.controlName + '')"
        >
        </app-c-input>

        <div
          *ngIf="input.controlName && input?.select"
          class="form-conteudo-cinput d-flex direction-column"
        >
          <label class="input-label" for="select-beneficiary">
            Tipo de Beneficiário
          </label>
          <select
            id="select-beneficiary"
            class="form-conteudo-cselect"
            [formControlName]="input.controlName"
          >
            <option [value]="null" hidden disabled>Tipo de Beneficiário</option>
            <ng-container *ngFor="let beneficiary of beneficiaryTypes">
              <option
                *ngIf="
                  (beneficiary.Name !== 'Subsidiaria' &&
                    beneficiary.Name !== 'Credimorar' &&
                    !data.form) ||
                  ((beneficiary.Name === 'Subsidiaria' ||
                    beneficiary.Name === 'Credimorar') &&
                    data.form) ||
                  (beneficiary.Name !== 'Subsidiaria' &&
                    beneficiary.Name !== 'Credimorar' &&
                    data.form)
                "
                [value]="beneficiary.BeneficiaryTypeId"
                (click)="setBeneficiaryName(beneficiary.Name)"
              >
                {{ beneficiary.Name }}
              </option>
            </ng-container>
          </select>
        </div>
      </ng-container>
    </div>

    <button
      class="d-flex align-center form-add add ui-btn ui-btn--primary"
      (click)="close(true)"
      *ngIf="!data.form"
    >
      Adicionar Beneficiário
    </button>

    <button
      class="d-flex align-center form-add add ui-btn ui-btn--primary"
      (click)="close(true)"
      *ngIf="data.form"
    >
      Editar Beneficiário
    </button>
  </form>
</mat-dialog-content>
